import SegmentationFilters from './SegmentationFilters';

export default SegmentationFilters;
